// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { Pessoa } from '../comum/pessoa.model';
import { Contrato } from './contrato.model';

export class ContratoTestemunha extends BaseResourceModel {
  constructor(
    public id?: number,
    public pessoa?: Pessoa,
    public contrato?: Contrato,
  ) {
    super();
  }

  static converteJson(json: any): ContratoTestemunha {
    return Object.assign(new ContratoTestemunha(), json);
  }
}
